// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3aTZ6","inputWrap":"styles_inputWrap__1K67b","input":"styles_input__2o7M1"};